import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { registerNavigate } from './navigate'

/**
 * Registers the router's `navigate` fn with the imperative `navigate` seam so
 * non-component code can navigate. Render once inside the Router. Renders
 * nothing.
 */
export function NavigationBridge() {
  const navigate = useNavigate()
  useEffect(() => {
    registerNavigate(navigate)
  }, [navigate])
  return null
}
